import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  Avatar,
  Container,
  CircularProgress,
  Button,
  useMediaQuery,
} from '@material-ui/core';

import { Link } from 'react-router-dom';
import {
  Logo,
  TotalBalance,
  MenuRight,
  useStyles,
} from './HeaderStyles';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { headerRequest } from '../../store/modules/header/actions';
import { clearDemoData } from '../../store/modules/user/actions';
import { logOut } from '../../store/modules/auth/actions';
import { ApplicationState } from '../../store';
import { formatPrice } from '../../utils/functions';
import api from '../../services/api';
import AnimatedNumber from '../../pages/Private/Home/Boxes/_Common/AnimatedNumber';
import logoimage from '../../files/images/logo.png';
import logoicon from '../../files/images/logo-icon.png';
import history from '../../services/history';

export default function Header() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const headerState = useSelector((state: ApplicationState) => state.header);
  const userState = useSelector((state: ApplicationState) => state.user);
  const matches = useMediaQuery('(min-width:714px)');
  const showTradeUsage = useMediaQuery('(min-width:486px)');


  const [billingStatus, setBillingStatus] = useState<any>(null);

  useEffect(() => {
    dispatch(headerRequest());
    api.get('/billing/status').then(res => {
      setBillingStatus(res.data);
    }).catch(() => {});
  }, []); // eslint-disable-line

  const regInitials = userState.user.name.match(/\b\w/g) || [];

  const initials = (
    (regInitials.shift() || '') + (regInitials.pop() || '')
  ).toUpperCase();

  const subscription = billingStatus || userState.user.subscription || {};
  const trial = userState.user.trial;
  const tradeCount = (billingStatus && billingStatus.tradeCount) || 0;
  const tradeLimit = subscription.tradeLimit || 0;
  const usagePercent = tradeLimit > 0 ? (tradeCount / tradeLimit) * 100 : 0;
  const isTrialing = subscription.status === 'trialing' || (trial && trial.active);
  const trialDaysRemaining = (trial && trial.daysRemaining != null)
    ? trial.daysRemaining
    : (
      subscription.currentPeriodEnd
        ? Math.max(0, Math.ceil((new Date(subscription.currentPeriodEnd).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
        : 0
    );
  return (
    <Container className={classes.container}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '40%',
        }}
      >
        <Logo>
          <Link to="/">
            {matches ? (
              <img alt="logo" src={logoimage} style={{ width: '220px' }} />
            ) : (
              <img alt="logo" src={logoicon} style={{ height: '40px' }} />
            )}
          </Link>
        </Logo>
      </div>

      <Tooltip title="Mantenha seu saldo atualizado adicionando trades, depósitos e retiradas" placement="bottom">
        <TotalBalance>
          {(headerState.loading && headerState.balance === 0 && <CircularProgress size={28} style={{ color: '#ffffff33' }} />) || (
            <Typography variant="h4" color="primary" component="h1">
              <AnimatedNumber
                value={headerState.balance}
                formatFn={formatPrice}
              />
            </Typography>
          )}
          <Typography variant="caption">saldo atual</Typography>
        </TotalBalance>
      </Tooltip>
      <MenuRight>
        {userState.user.hasDemoData && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            backgroundColor: '#625c27',
            padding: '7px 10px',
            borderRadius: '6px',
            marginRight: '8px',
          }}>
            <InfoIcon style={{ color: '#ffee58', fontSize: '24px' }} />
            <Typography style={{ fontSize: '14px', color: '#ffffffcc', whiteSpace: 'nowrap' }}>
              Estes são dados de exemplo, remova-os e cadastre seus proprios trades!
            </Typography>
            <Button
              size="small"
              onClick={() => dispatch(clearDemoData())}
              style={{
                color: '#ffffffcf',
                fontSize: '13px',
                textTransform: 'none',
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                padding: '0px 6px',
                borderColor: '#FF7A6366',
                backgroundColor: '#FF7A63',
              }}
              variant="outlined"
            >
              Remover
            </Button>
          </div>
        )}
        {isTrialing && trialDaysRemaining >= 0 && (
          <Link to="/plans" style={{ textDecoration: 'none' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: '#625c27',
              padding: '7px 12px',
              borderRadius: '6px',
              marginRight: '8px',
            }}>
              <Typography style={{ fontSize: '13px', color: '#ffee58', whiteSpace: 'nowrap', fontWeight: 600 }}>
                Trial: {trialDaysRemaining} {trialDaysRemaining === 1 ? 'dia restante' : 'dias restantes'}
              </Typography>
            </div>
          </Link>
        )}
        {showTradeUsage && subscription && (subscription.status === 'active' || isTrialing) && tradeLimit > 0 && (
          <Tooltip title={
            tradeCount + ' de ' + tradeLimit + ' trades usados' +
            (subscription.currentPeriodEnd ? '. Renova em ' + new Date(subscription.currentPeriodEnd).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '') +
            (subscription.plan !== 'premium' ? '. Clique para fazer upgrade' : '')
          } placement="bottom">
            <div
              onClick={subscription.plan !== 'premium' ? () => history.push('/plans') : undefined}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: '#1E2141',
                borderRadius: '20px',
                padding: '4px 12px',
                cursor: subscription.plan !== 'premium' ? 'pointer' : 'default',
              }}
            >
              <div style={{
                width: '60px',
                height: '5px',
                borderRadius: '3px',
                background: '#ffffff1a',
                overflow: 'hidden',
              }}>
                <div style={{
                  width: `${Math.min(usagePercent, 100)}%`,
                  height: '100%',
                  borderRadius: '3px',
                  background: usagePercent > 90 ? '#FF6347' : usagePercent > 70 ? '#ffee58' : '#4BDC4B',
                  transition: 'width 0.3s ease',
                }} />
              </div>
              <span style={{
                fontSize: '12px',
                fontWeight: 600,
                color: usagePercent > 90 ? '#FF6347' : usagePercent > 70 ? '#ffee58' : '#ffffffcc',
                whiteSpace: 'nowrap',
              }}>
                {tradeCount}/{tradeLimit}
              </span>
            </div>
          </Tooltip>
        )}
        <Link to="/account">
          <Tooltip title="Minha conta" placement="bottom">
            <Avatar className={classes.avatar}>{initials}</Avatar>
          </Tooltip>
        </Link>
        {window.location.pathname === '/plans' && (!subscription.plan || subscription.plan === 'free') && (
          <Button
            onClick={() => dispatch(logOut())}
            startIcon={<ExitToAppIcon />}
            style={{
              color: '#ffffffcc',
              textTransform: 'none',
              fontSize: '13px',
              minWidth: 'auto',
              padding: '4px 8px',
            }}
          >
            Sair
          </Button>
        )}
      </MenuRight>
    </Container>
  );
}
